import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarContribuinteDs,
  criarTaxasDs,
  criarLancamentoTaxasDs,
} from "../../DataSources";
import { Button } from "devextreme-react";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import uiInfo from "../../ui-info";
import ScrollView from "devextreme-react/scroll-view";
import ShowError from "../../AppServices";
import { abrirDetalhe } from "../../lancamentosUtils";
import Memoria from "../../Memoria";

const _versaoCadastro = 1;
let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  prefeituraId: undefined,
  contribuinteId: undefined,
  taxaId: undefined,
  ano: undefined,
  exercicio: undefined,
  numero: undefined,
  _uiNumeroCompleto: "",
  competencia: undefined,
  data: new Date(),
  dataDeVencimento: undefined,
  qtde: 1,
  valorUnitario: 0,
  total: 0,
  historico: "",
  popupVisivel: false,
  _tipoCobranca: "",
  _descricaoTaxa: "",
  calculoVisivel: true,
  qtdeSomenteLeitura: true,
  valorUnitarioSomenteLeitura: true,
  situacaoLancamentoStr: "N",
  exibirPopupPreview: false,
};

export default class LancamentoTaxasForm extends React.Component {
  constructor(props) {
    const data = new Date();
    const competencia =
      (data.getMonth() + 1).toString().padStart(2, "0") +
      "/" +
      data.getFullYear();
    super(props);
    this.saidaProgramada = false;
    template.prefeituraId = UserInfo.getPrefeitura();
    template.competencia = competencia;
    template.ano = data.getFullYear();
    template.exercicio = data.getFullYear();
    this.confirmar = this.confirmar.bind(this);
    this.confirmarPopup = this.confirmarPopup.bind(this);
    this.confirmarTela = this.confirmarTela.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = {
      ...template,
      prefeituraId: UserInfo.getPrefeitura(),
      data,
      competencia,
      dataDeVencimento: data,
      ano: new Date().getFullYear(),
    };
    this.lancamentoTaxaDs = criarLancamentoTaxasDs();
    this.contribuinteDs = criarContribuinteDs();
    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.pesquisarContribuinte = this.pesquisarContribuinte.bind(this);
    this.onContribuinteSelecionadoPesquisa =
      this.onContribuinteSelecionadoPesquisa.bind(this);
    this.contribuinteBoxRef = React.createRef();
    this.renderContribuinte = sysCodigoDescricao(
      () => this.state.contribuinteId,
      this.setContribuinteId,
      () => this.state._uiNomeContribuinte,
      this.pesquisarContribuinte
    );

    this.onFecharPopup = this.onFecharPopup.bind(this);
    this.onTaxaSelecionada = this.onTaxaSelecionada.bind(this);

    this.taxaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      searchPlaceholder: "Procurar",
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: criarTaxasDs(),
      displayExpr: "descricao",
      valueExpr: "id",
      onValueChanged: this.onTaxaSelecionada,
      onSelectionChanged: this.onTaxaSelecionada,
    };

    this.taxaDs = criarTaxasDs();
    this.criarHistorico = this.criarHistorico.bind(this);
    this.itemLeitura = this.itemLeitura.bind(this);
    this.itemLeituraMoeda = this.itemLeituraMoeda.bind(this);
  }

  itemLeitura(data) {
    if (this.state.previewData == undefined) {
      return <span></span>;
    }
    return <span>{this.state.previewData[data.dataField]}</span>;
  }

  itemLeituraMoeda(data) {
    let valor;
    if (this.state.previewData != undefined) {
      valor = this.state.previewData[data.dataField];
    }
    let str = "";
    if (valor !== undefined) {
      str = valor.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    }

    return <span>{str}</span>;
  }

  criarHistorico(descricaoTaxa, quantidade, competencia) {
    const _descricao = descricaoTaxa ?? this.state._descricaoTaxa;
    const _qtde = quantidade ?? this.state.qtde;
    const _qtdeStr = (Math.round(_qtde * 100) / 100)
      .toFixed(2)
      .toString()
      .replace(".", ",");
    const _competencia = competencia ?? this.state.competencia;

    return `${_descricao}\nQuantidade: ${_qtdeStr}\nCompetência: ${_competencia}`;
  }

  onCampoHistoricoAtualizado() {
    this.setState({ historico: this.criarHistorico() });
  }

  onTaxaSelecionada(e) {
    console.log("e taxa selecionada", e);
    if (e.event) {
      let calculoVisivel = true;
      let qtdeSomenteLeitura = true;
      let valorUnitarioSomenteLeitura = true;
      let tipoCobranca = "";
      let taxaId = e.value;
      let valorUnitario = this.state.valorUnitario;

      if (taxaId !== undefined) {
        this.taxaDs
          .byKey(taxaId)
          .then((taxa) => {
            console.log("taxa selecionada", taxa);

            if (taxa.tipoDeCobranca === 0) {
              tipoCobranca = "Por Quantidade";
              calculoVisivel = true;
              qtdeSomenteLeitura = false;
              valorUnitarioSomenteLeitura = false;
              valorUnitario = taxa.valor;
            } else if (taxa.tipoDeCobranca === 1) {
              tipoCobranca = "Por Faixa";
              calculoVisivel = false;
              qtdeSomenteLeitura = false;
              valorUnitarioSomenteLeitura = true;
              valorUnitario = 1;
            } else if (taxa.tipoDeCobranca === 2) {
              tipoCobranca = "Por Valor Fixo";
              calculoVisivel = true;
              qtdeSomenteLeitura = false;
              valorUnitarioSomenteLeitura = true;
              valorUnitario = taxa.valor;
            } else if (taxa.tipoDeCobranca === 3) {
              tipoCobranca = "Por Faixa - Tabela de Preços";
              calculoVisivel = false;
              qtdeSomenteLeitura = false;
              valorUnitarioSomenteLeitura = true;
              valorUnitario = 1;
            } else if (taxa.tipoDeCobranca === 4) {
              tipoCobranca = "Por Valor Total Fixo";
              calculoVisivel = true;
              qtdeSomenteLeitura = false;
              valorUnitarioSomenteLeitura = true;
              valorUnitario = taxa.valor;
            }
            

            const historico = this.criarHistorico(taxa.descricao);

            this.setState({
              calculoVisivel,
              qtdeSomenteLeitura,
              valorUnitarioSomenteLeitura,
              _tipoCobranca: tipoCobranca,
              _descricaoTaxa: taxa.descricao,
              valorUnitario,
              historico,
            });
          })
          .catch((error) => {
            ShowError(error);
          });
      }
    }
  }

  onFecharPopup() {
    this.setState({ popupVisivel: false });
  }

  setContribuinteId(data) {
    this.setState({ contribuinteId: data.value });
    this.atualizarNomeContribuinte();
  }

  atualizarNomeContribuinte() {
    this.contribuinteDs
      .load({ filter: [["sequencial", "=", this.state.contribuinteId]] })
      .then((result) => {
        console.log(result);
        if (result.length !== 0) {
          this.setNomeContribuinte(result[0]);
        } else {
          this.setNomeContribuinte(undefined);
        }
      })
      .catch((_) => this.setNomeContribuinteErro());
  }

  setNomeContribuinte(contribuinte) {
    if (contribuinte === undefined) {
      this.setState({ _uiNomeContribuinte: "" });
    } else {
      this.setState({ _uiNomeContribuinte: contribuinte.nome });
    }
  }

  setNomeContribuinteErro() {
    this.setState({ _uiNomeContribuinte: "<<ERRO>>" });
  }

  onContribuinteSelecionadoPesquisa(e) {
    this.setState({
      contribuinteId: e.row.data.sequencial,
      popupVisivel: false,
    });
    this.atualizarNomeContribuinte();
  }

  pesquisarContribuinte() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.setState({ popupVisivel: true });
  }

  componentDidMount() {
    _cadastroCorrente = Memoria.resturarEstado(
      this.props.location,
      _cadastroCorrente,
      _versaoCadastro
    );

    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        console.log("lançamento taxas params id", this.props.match.params.id);
        this.lancamentoTaxaDs
          .load({ filter: [["sequencial", "=", this.props.match.params.id]] })
          .then((response) => {
            if (response.length == 0) {
              notify("Taxa não encontrada.", "error");
              this.props.history.push("/lancamentotaxas");
            }
            const data = response[0];
            console.log("lançamaneto aberto taxa", data);

            const taxa = data.taxa;

            let calculoVisivel = true;
            let qtdeSomenteLeitura = true;
            let valorUnitarioSomenteLeitura = true;
            let tipoCobranca = "";

            if (taxa.tipoDeCobranca === 0) {
              tipoCobranca = "Por Quantidade";
              calculoVisivel = true;
              qtdeSomenteLeitura = false;
              valorUnitarioSomenteLeitura = false;
            } else if (taxa.tipoDeCobranca === 1) {
              tipoCobranca = "Por Faixa";
              calculoVisivel = false;
              qtdeSomenteLeitura = false;
              valorUnitarioSomenteLeitura = true;
            } else if (taxa.tipoDeCobranca === 2) {
              tipoCobranca = "Por Valor Fixo";
              calculoVisivel = true;
              qtdeSomenteLeitura = false;
              valorUnitarioSomenteLeitura = true;
            }

            this.setState({
              id: data.id,
              prefeituraId: data.prefeituraId,
              contribuinteId: data.contribuinte.sequencial,
              _uiNomeContribuinte: data.contribuinte.nome,
              taxaId: data.taxaId,
              ano: data.ano,
              numero: data.numeroLancamento,
              _uiNumeroCompleto: data.numeroCompleto,
              competencia: data.competenciaLancamento,
              data: data.dataLancamento,
              dataDeVencimento: data.vencimentoAlvara,
              qtde: data.qtdeLancamento,
              valorUnitario: data.valorUnitarioLancamento,
              total: data.ValorDoImposto,
              historico: data.historico,
              popupVisivel: false,
              _tipoCobranca: tipoCobranca,
              _descricaoTaxa: data.taxa.descricao,
              calculoVisivel: calculoVisivel,
              qtdeSomenteLeitura: qtdeSomenteLeitura,
              valorUnitarioSomenteLeitura: valorUnitarioSomenteLeitura,
              situacaoLancamentoStr: data.situacaoStr,
            });
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      } else {
        this.setState({ ...template });
      }
    } else {
      this.setState({ ..._cadastroCorrente });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={3}>
              <GroupItem caption="LANÇAMENTO DE TAXAS" colSpan={3} colCount={4}>
                <SimpleItem
                  colSpan={1}
                  dataField={"_uiNumeroCompleto"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Número" />
                </SimpleItem>

                <SimpleItem
                  dataField={"data"}
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%" }}
                >
                  <Label text="Data" />
                </SimpleItem>

                <SimpleItem
                  dataField={"dataDeVencimento"}
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%" }}
                >
                  <Label text="Vencimento" />
                </SimpleItem>

                <SimpleItem
                  dataField={"competencia"}
                  editorOptions={{
                    onValueChanged: (e) => {
                      this.setState({ historico: this.criarHistorico() });
                    },
                  }}
                >
                  <Label text="Competência" />
                </SimpleItem>

                <SimpleItem colSpan={4} component={this.renderContribuinte}>
                  <Label text="Contribuinte" />
                </SimpleItem>

                <SimpleItem
                  colSpan={3}
                  dataField={"taxaId"}
                  editorType={"dxLookup"}
                  editorOptions={this.taxaOptions}
                  onValueChanged={this.onTaxaSelecionada}
                >
                  <Label text="Taxa" />
                </SimpleItem>

                <SimpleItem
                  dataField={"_tipoCobranca"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Tipo de Cobrança" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"qtde"}
                  editorType={"dxNumberBox"}
                  cssClass="box-n2"
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                    readOnly: this.state.qtdeSomenteLeitura,
                    onValueChanged: (e) => {
                      if (e.event) {
                        let value = this.state.valorUnitario * e.value;
                        this.setState({
                          total: value !== 0 ? value : 0,
                          historico: this.criarHistorico(),
                        });
                      }
                    },
                  }}
                >
                  <Label text="Quantidade" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"valorUnitario"}
                  editorType={"dxNumberBox"}
                  cssClass="box-n2"
                  visible={this.state.calculoVisivel}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                    readOnly: this.state.valorUnitarioSomenteLeitura,
                    onValueChanged: (e) => {
                      let value = this.state.qtde * e.value;
                      this.setState({ total: value !== 0 ? value : 0 });
                    },
                  }}
                >
                  <Label text="Valor Unitário" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"total"}
                  editorType={"dxNumberBox"}
                  cssClass="box-n2 readOnlyBox"
                  visible={this.state.calculoVisivel}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                    readOnly: true,
                  }}
                >
                  <Label text="Total" />
                </SimpleItem>
                <EmptyItem visible={this.state._tipoCobranca !== "Por Faixa"} />
                <EmptyItem
                  colSpan={3}
                  visible={this.state._tipoCobranca === "Por Faixa"}
                />
                <SimpleItem
                  dataField={"historico"}
                  editorType={"dxTextArea"}
                  editorOptions={{ height: "120px" }}
                  colSpan={4}
                >
                  <Label text="Histórico" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "left",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Pré-visualizar"
                  type="default"
                  onClick={this.confirmarTela}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.confirmarPopup}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} />
              </div>
            </div>
          </form>
          <Popup
            visible={this.state.popupVisivel}
            onHiding={this.hideInfo}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Contribuinte"
            onHiding={this.onFecharPopup}
          >
            <ScrollView showScrollbar={"always"}>
              <ContribuinteBox
                onSelecionado={this.onContribuinteSelecionadoPesquisa}
                ref={this.contribuinteBoxRef}
              />
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
          <Popup
            visible={this.state.exibirPopupPreview}
            onHiding={this.hideInfo}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={600}
            height={350}
            title="Confirmação dos dados"
          >
            <ScrollView showScrollbar="always">
              <form>
                <Form formData={this.state.previewData}>
                  <SimpleItem dataField={"nome"} render={this.itemLeitura}>
                    <Label text="Nome" />
                  </SimpleItem>

                  <SimpleItem dataField={"cpfCnpj"} render={this.itemLeitura}>
                    <Label text="CPF/CNPJ" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"enderecoL1"}
                    render={this.itemLeitura}
                  >
                    <Label text="Endereco" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"enderecoL2"}
                    render={this.itemLeitura}
                  >
                    <Label text=" " showColon={false} />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"valor"}
                    render={this.itemLeituraMoeda}
                  >
                    <Label text="Valor" />
                  </SimpleItem>
                </Form>
              </form>
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Confirmar",
                type: "success",
                width: 150,
                onClick: this.confirmarPopup,
              }}
            ></ToolbarItem>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Cancelar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ exibirPopupPreview: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  confirmarTela() {
    this.confirmar(true);
  }

  confirmarPopup() {
    this.confirmar(false);
  }

  confirmar(preview) {
    const entidade = {
      ...this.state,
      prefeituraId: UserInfo.getPrefeitura(),
      preview,
    };
    inserirOuAtualizar(this.lancamentoTaxaDs, entidade).then(
      function (data) {
        if (preview) {
          this.setState({
            exibirPopupPreview: true,
            previewData: {
              nome: data.lancamento.contribuinte.nome,
              fantasia: data.lancamento.contribuinte.fantasia,
              cpfCnpj: data.lancamento.contribuinte.documentoFormatado,
              enderecoL1: data.lancamento.contribuinte.logradouroComNumero,
              enderecoL2: data.lancamento.contribuinte.enderecoL2,
              ano: data.lancamento.ano,
              exercicio: data.lancamento.exercicio,
              valor: data.lancamento.valorDoImposto,
              situacao: data.lancamento.situacao.descricao,
              valor: data.lancamento.valorDoImposto,
            },
          });
        } else {
          notify("Lançamento realizado com sucesso.", "success");
          _cadastroCorrente = undefined;
          _cancelando = true;
          Memoria.removerEdicao(this.props.location);
          abrirDetalhe(this.props.history, data);
        }
      }.bind(this)
    );
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    Memoria.removerEdicao(this.props.location);
    this.props.history.goBack();
  }
}
